import { useEffect, useRef, useState } from 'react';

const useGenerationCountdown = (
	totalDuration,
	isActive = true,
	onComplete,
) => {
	const [remainingTime, setRemainingTime] = useState(totalDuration);
	const onCompleteRef = useRef(onComplete);

	onCompleteRef.current = onComplete;

	useEffect(() => {
		if (!isActive) {
			setRemainingTime(totalDuration);
			return undefined;
		}

		setRemainingTime(totalDuration);
		const startTime = Date.now();
		let completed = false;

		const interval = window.setInterval(() => {
			const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
			const nextRemaining = Math.max(0, totalDuration - elapsedSeconds);

			setRemainingTime(nextRemaining);

			if (elapsedSeconds >= totalDuration && !completed) {
				completed = true;
				window.clearInterval(interval);
				onCompleteRef.current?.();
			}
		}, 250);

		return () => window.clearInterval(interval);
	}, [totalDuration, isActive]);

	return remainingTime;
};

export default useGenerationCountdown;
